var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_structure_wrapper"},[_c('TheHeader'),_c('section',{staticClass:"main_content",staticStyle:{"background-color":"white !important"}},[_c('transition',{attrs:{"name":"fadeInUp","mode":"out-in"}},[_c('router-view')],1)],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }